import { gql } from '@apollo/client';
import { Product } from './models/product';

export interface ProductsQueryResult {
  products: Product[];
}

export const GET_PRODUCTS_QUERY = gql`
  query getProducts {
    products {
      productId
      name
      features {
        briefs
        recipientsPerBrief
        keywordsPerBrief
        slackEnabled
        zapierEnabled
      }
      plans {
        name
        planId
        productId
        monthlyPrice
        price
        periodicity
      }
      mostPopular
      published
    }
  }
`;
